import { PlaceDto } from '@proxy/places';
import { AppConsts } from '../AppConsts';
import { UserPlaceService as UserPlaceServiceProxy } from '@proxy/user-places';
import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UserPlaceService {
    private currentPlace: PlaceDto;
    private currentPlacesAvailables: PlaceDto[];

    constructor(
        private readonly _userPlaceService: UserPlaceServiceProxy
    ) {
        this.addRefreshEventListener();
    }

    async getCurrentUserPlace(): Promise<PlaceDto> {
        if (this.currentPlace) {
            return this.currentPlace;
        }

        const userPlaceInformation = await firstValueFrom(this._userPlaceService.getCurrentUserPlace());

        this.currentPlace = userPlaceInformation;
        return this.currentPlace;
    }

    async getCurrentUserPlaceBasicInformation(): Promise<PlaceDto> {
        if (this.currentPlace) {
            return this.currentPlace;
        }

        const userPlaceInformation = await firstValueFrom(this._userPlaceService.getCurrentUserPlace());

        this.currentPlace = userPlaceInformation;
        return this.currentPlace;
    }

    async getUserPlaceAvailables(): Promise<PlaceDto[]> {
        if (this.currentPlacesAvailables) {
            return this.currentPlacesAvailables;
        }

        this.currentPlacesAvailables = await firstValueFrom(this._userPlaceService.getCurrentUserAvailablePlaces());
        return this.currentPlacesAvailables;
    }

    refreshCurrentUserPlace(): void {
        localStorage.setItem(AppConsts.RefreshTabsEvent, JSON.stringify(new Date()));
        location.reload();
    }
    
    private addRefreshEventListener(): void {
        addEventListener(AppConsts.LocalStorageKey, this.refreshOnLocationChange);
    }
    
    private refreshOnLocationChange(event: StorageEvent): void {
        if (event.key === AppConsts.RefreshTabsEvent && event.newValue) {
            localStorage.removeItem(AppConsts.RefreshTabsEvent);
            location.reload();
        }
    }
}